module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAADAAAAACRRQtxAAAA3UlEQVQoFZ2RvQrCMBCA7wp2qOLYyc3Rp3BUHH0On8AXcFPwLVzFUQR9B8cEFUk6C9IUPZNo2wy12h4kXMJ93+UHoUZciQIl1QoQ215V/g0nawIY6nHHKoIcpj4iHgJsDP7mDcyF2jIRE5dqH0XUsjCT8YyLZFpm+gobiIv4aKxMqEWRpBTWgOehP0KECwBNWKTmrqTozmGIN7fG5idJXS7jsz3JR/KrcyrJfsFInqB2RNBBwKUu6BHkr13YWRdlAmN0JWadftU32NaYyQ0jeYDa6D3WRH9cBrtc7fwFP2GrR4L6acsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/confirm.png
// module id = khoF
// module chunks = 1